import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import {Divider, Typography, Slider, Select, Space, Tag} from 'antd';
import { ArrowRightOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, ButtonGroup, Switch, FormControlLabel } from '@mui/material';
import { ArrowForwardIosSharp } from "@mui/icons-material";
import BlacklistInstance from "../../../Blacklist/components/BlacklistInstance";
import Alert from "@mui/material/Alert";
import { stringMixin } from "../../../../utils/strings";

const { Option } = Select;


const getEtfsBelowTolerance = (etfs, minWeightTolerance)=>{
    const keys = Object.keys(etfs).filter(x=>etfs[x] < minWeightTolerance);
    if (!keys || keys.length === 0) return null;
    return keys.map(key=>({
        symbol: key,
        contribution: etfs[key],
        difference: minWeightTolerance - etfs[key]
    }))
}


const SmaMenu = ({
    onSubmit,
    blacklists,
    screens,
    config,
    updateConfig,
    etfContributions
}) => {
    const [blaclistDrawerVisible, setBlacklistDrawerVisible] = useState(false);
    const navigate = useNavigate();
    const atLeastOneNotReplicated = Object.keys(config.etfs).some(etf => config.etfs[etf].doNotReplicate);
    const etfsNotReplicated = Object.keys(config.etfs).filter(etf => config.etfs[etf].doNotReplicate);
    let etfsBelowTolerance = getEtfsBelowTolerance(etfContributions, config.minWeightTolerance * 0.01);
    if (etfsBelowTolerance && etfsNotReplicated.length>0) {
        etfsBelowTolerance = etfsBelowTolerance.filter(etf => !etfsNotReplicated.includes(etf.symbol));
    }

    console.log(config)


    return (
        <div style={{ padding: '20px'}} className={'bordered round-2'}>
            {
              atLeastOneNotReplicated && (
                  <>
                    <Alert variant="filled" severity="error" sx={{padding: '0px 8px',fontSize: '0.75rem', '& .MuiAlert-icon': { fontSize: '0.8rem'}}}>
                      Building Multi-Asset SMA
                    </Alert>
                      <Divider/>
                  </>
              )
            }
            <ButtonGroup>
                <Button variant={config?.fillType === 'equal' ? 'contained' : 'outlined'}
                        onClick={() => updateConfig('fillType', 'equal')}
                        size={'small'}>
                    Equal
                </Button>
                <Button variant={config?.fillType === 'prorata' ? 'contained' : 'outlined'}
                        onClick={() => updateConfig('fillType', 'prorata')}
                        size={'small'}>
                    Pro Rata
                </Button>
                <Button variant={config?.fillType === 'sectors' ? 'contained' : 'outlined'}
                        onClick={() => updateConfig('fillType', 'sectors')}
                        size={'small'}>
                    Sectors
                </Button>
            </ButtonGroup>
            <Divider />
            <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Select a Blacklist"
                optionFilterProp="children"
                onChange={(value) => updateConfig('blacklistId', value)}
                value={config.blacklistId}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                suffixIcon={<><span>{blacklists.length}</span><PlusOutlined style={{ color: '#029EFF' }} onClick={() => setBlacklistDrawerVisible(true)} /></>}
            >
                {blacklists.map((blacklist) => (
                    <Option key={blacklist.id} value={blacklist.id}>{blacklist.title}</Option>
                ))}
            </Select>

            {/* Show "Remove" text if a blacklist is selected */}
            {config.blacklistId && (
                <Typography.Text type="danger" onClick={() => updateConfig('blacklistId', null)} style={{ cursor: 'pointer' }}>
                    Remove
                </Typography.Text>
            )}

            <Divider className={'borderless'} />
            <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Select a Screen"
                optionFilterProp="children"
                onChange={(value) => updateConfig('screenerId', value)}
                value={config.screenerId}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                suffixIcon={<><span>{screens.length}</span><ArrowRightOutlined onClick={() => navigate('/screener')} style={{ color: '#029EFF' }} /></>}
            >
                {screens.map((screen) => (
                    <Option key={screen.id} value={screen.id}>{screen.title}</Option>
                ))}
            </Select>

            {/* Show "Remove" text if a screener is selected */}
            {config.screenerId && (
                <Typography.Text type="danger" onClick={() => updateConfig('screenerId', null)} style={{ cursor: 'pointer' }}>
                    Remove
                </Typography.Text>
            )}
            <Divider className={'borderless'} />
            <Typography.Text>Cutoff Percent: {config.cutoffWeight || 80 }%</Typography.Text>
            <Slider
                min={30}
                max={100}
                value={config.cutoffWeight || 80}
                onChange={(value) => { updateConfig('cutoffWeight', value) }}
                step={2.5}
            />
            <Divider />
            <Typography.Text>Min Representation: {config.minWeightTolerance}%</Typography.Text>
            <Slider
                min={0} max={20} value={config.minWeightTolerance} onChange={(value) => { updateConfig('minWeightTolerance', value) }} step={0.25} />
            <Divider />
            {config.fillType === 'sectors' && (
                <>
                    <Typography.Text>Sector Tolerance: {config?.minSectorTolerance * 100 || 0}%</Typography.Text>
                    <Slider min={0.25} max={10} value={config?.minSectorTolerance * 100 || 0} onChange={(value) => { updateConfig('minSectorTolerance', value * 0.01) }} step={0.25} />
                    <Divider />
                </>
            )}
            {/*<Typography.Text>Max per Holding: {config.maxPerHolding}%</Typography.Text>*/}
            {/*<Slider min={0} max={25} value={config.maxPerHolding} onChange={(value) => { updateConfig('maxPerHolding', value) }} step={0.5} />*/}

            {/*<Divider />*/}
            {
                etfsBelowTolerance && (
                    <Space direction={'vertical'} size={'large'}>
                        <Typography.Title level={5}>Tickers Under Represented ({etfsBelowTolerance.length})</Typography.Title>
                        <Space size={'large'} wrap={true}>
                            {etfsBelowTolerance.map((etf, index) => (
                                <Tag>
                                    <Typography.Text key={index} strong>{etf.symbol.toUpperCase()}</Typography.Text>

                                    <Typography.Text style={{color: 'var(--red)', marginLeft: '10px'}} strong={true}>
                                        -{stringMixin.pct(etf.difference)}

                                    </Typography.Text>
                                </Tag>
                            ))}
                        </Space>
                        <Divider/>
                    </Space>
                )
            }
            {
                etfsNotReplicated && (
                    <Space direction={'vertical'} size={'large'}>
                        <Typography.Title level={5}>ETFs Not Replicated ({etfsNotReplicated.length})</Typography.Title>
                        <Space size={'large'} wrap={true}>
                            {etfsNotReplicated.map((etf, index) => (
                                <Tag>
                                    <Typography.Text key={index} strong>{etf.toUpperCase()}</Typography.Text>

                                </Tag>
                            ))}
                        </Space>
                        <Divider/>
                    </Space>
                )
            }
            {blaclistDrawerVisible && <BlacklistInstance onClose={() => setBlacklistDrawerVisible(false)} />}

        </div>
    );
};

export default SmaMenu;
